import SelfServiceHorizontal from '@assets/ss_graphic_horizontal.svg';
import SelfServiceVertical from '@assets/ss_graphic_vertical.svg';
import ImprivataIdImg from '@assets/uss_imprivata_id_authenticator.svg';
import PasswordImg from '@assets/uss_password_authenticator.svg';
import AuthenticatorList from '@selfservice/containers/AuthenticatorList';
import AuthMethodLayout from '@selfservice/containers/AuthMethods/AuthMethodLayout';
import FaceCapture from '@selfservice/containers/AuthMethods/FaceCapture/FaceCapture';
import IdentityPassword from '@selfservice/containers/AuthMethods/IdentityPassword/IdentityPassword';
import UpdateBioAgreement from '@selfservice/containers/AuthMethods/UpdateBioAgreement/UpdateBioAgreement';
import EpcsSetup from '@selfservice/containers/EpcsSetup/EpcsSetup';
import { Route, Routes } from 'react-router-dom';
import { featureSupported } from '../featureFlagsUtils';
import EnrollImprivataId from './containers/AuthMethods/ImprivataId/EnrollImprivataId';
import SelfService from './index';
import OtpRouteGuard from './containers/AuthMethods/Otp/OtpRouteGuard';

export enum SelfServicePath {
  SELF_SERVICE_ENROLL_FACE = '/face/enroll',
  SELF_SERVICE_IDENTITY_PASSWORD = '/password',
  SELF_SERVICE_ENROLL_IMPRIVATA_ID = '/imprivata-id/enroll',
  SELF_SERVICE_OTP = '/otp',
  SELF_SERVICE_EPCS = '/epcs',
  SELF_SERVICE_UPDATE_BIO_AGREEMENT = '/face/bio-agreement',
}

const ENABLE_EPCS = featureSupported('ENABLE_EPCS');

const SelfServiceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SelfService />}>
        <Route index element={<AuthenticatorList />} />

        <Route
          path={SelfServicePath.SELF_SERVICE_ENROLL_FACE}
          element={
            <AuthMethodLayout
              graphic={
                <>
                  <img
                    src={SelfServiceVertical}
                    alt="Desktop"
                    className="left-panel-image-desktop"
                  />
                  <img
                    src={SelfServiceHorizontal}
                    alt="Mobile"
                    className="left-panel-image-mobile"
                  />
                </>
              }
            >
              <FaceCapture />
            </AuthMethodLayout>
          }
        />

        <Route
          path={SelfServicePath.SELF_SERVICE_UPDATE_BIO_AGREEMENT}
          element={
            <AuthMethodLayout
              graphic={
                <>
                  <img
                    src={SelfServiceVertical}
                    alt="Desktop"
                    className="left-panel-image-desktop"
                  />
                  <img
                    src={SelfServiceHorizontal}
                    alt="Mobile"
                    className="left-panel-image-mobile"
                  />
                </>
              }
            >
              <UpdateBioAgreement />
            </AuthMethodLayout>
          }
        />

        {ENABLE_EPCS && <Route path={SelfServicePath.SELF_SERVICE_EPCS} element={<EpcsSetup />} />}

        <Route
          path={SelfServicePath.SELF_SERVICE_IDENTITY_PASSWORD}
          element={
            <AuthMethodLayout
              graphic={
                <>
                  <img src={PasswordImg} alt="Desktop" className="left-panel-image-desktop" />
                  <img src={PasswordImg} alt="Mobile" className="left-panel-image-mobile" />
                </>
              }
            >
              <IdentityPassword />
            </AuthMethodLayout>
          }
        />

        <Route
          path={SelfServicePath.SELF_SERVICE_ENROLL_IMPRIVATA_ID}
          element={
            <AuthMethodLayout
              graphic={
                <>
                  <img src={ImprivataIdImg} alt="Desktop" className="left-panel-image-desktop" />
                  <img src={ImprivataIdImg} alt="Mobile" className="left-panel-image-mobile" />
                </>
              }
            >
              <EnrollImprivataId />
            </AuthMethodLayout>
          }
        />

        <Route path={SelfServicePath.SELF_SERVICE_OTP} element={<OtpRouteGuard />} />
      </Route>
    </Routes>
  );
};

export default SelfServiceRoutes;
